import { Grid, Paper } from '@mui/material';

import clsx from 'clsx';

import '../styles/Article.scss';

interface Props {
  icon: React.ReactNode;
  headline: string;
  description: string;
  active?: boolean;
}

export default function CategoryCard(props: Props) {
  return (
    <Grid
      component={Paper}
      elevation={3}
      className={clsx('articleModal__body__categories__category', {
        'articleModal__body__categories__category--active': props.active
      })}
    >
      <Grid
        container
        className="articleModal__body__categories__category__icon"
        justifyContent="center"
      >
        {props.icon}
      </Grid>
      <Grid
        container
        className="articleModal__body__categories__category__headline"
        justifyContent="center"
      >
        {props.headline}
      </Grid>
      <Grid
        container
        className="articleModal__body__categories__category__description"
        justifyContent="center"
      >
        {props.description}
      </Grid>
    </Grid>
  );
}
